import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export enum SendTaskDataAvailableProviders {
  AMASLIMT4 = 'AMASLIMT4',
  SDFBTM = 'SDFBTM',
  SDFCTM = 'SDFCTM',
  COBOINTOUCH = 'COBOINTOUCH',
  COBOINTOUCH_PFN = 'COBOINTOUCH_PFN',
  COBOINTOUCH_ARVATEC = 'COBOINTOUCH_ARVATEC',
  COBOINTOUCH_TEYME = 'COBOINTOUCH_TEYME',
  COBOINTOUCH_INDUSTRIAL = 'COBOINTOUCH_INDUSTRIAL',
  COBOINTOUCH_AGRO = 'COBOINTOUCH_AGRO',
  GOLDONI = 'GOLDONI',
  WAY = 'WAY',
  FADE = 'FADE',
  GEOTAB = 'GEOTAB',
  CNH = 'CNH',
  CNHMAP = 'CNHMAP',
  CNHGPS = 'CNHGPS',
  CLAAS = 'CLAAS',
  CLAAS_CONNECT = 'CLAAS_CONNECT',
  MATERMACC = 'MATERMACC',
  CLIMATEFIELDVIEW = 'CLIMATEFIELDVIEW',
  JOHN_DEERE = 'JOHN_DEERE',
  ARAG_YNNOVA = 'ARAG_YNNOVA',
  YNNOVA = 'YNNOVA',
  TRAKMATE = 'TRAKMATE',
  ALLYNAV = 'ALLYNAV',
}

export interface SendTaskDataRequest {
  url: string;
  externalId?: string;
  fieldActivityMetadata: {
    farm: string;
    client?: string;
    field?: string;
  };
}

@Injectable()
export class MapShapeService {
  private apiBaseUrl = environment.apiBaseUrl;
  private telemetryBaseUrl = environment.telemetryServiceUrl;
  private telemetryMachineryBaseUrl = environment.telemetryMachineryUrl;
  greenRedGradientColor = [
    '#198012',
    '#31a012',
    '#59bc21',
    '#76c714',
    '#aeea1e',
    '#f6fe28',
    '#f7e324',
    '#d6861a',
    '#ef5921',
    '#de2f10',
  ];
  blueRedGradientColor = [
    '#153FBE',
    '#1562CF',
    '#1484DF',
    '#13A6EF',
    '#13B7F7',
    '#13C0FB',
    '#A44B65',
    '#B13F57',
    '#CC283B',
    '#E6111F',
  ];
  blueGreyGradientColor = [
    '#153FBE',
    '#1562CF',
    '#1484DF',
    '#13A6EF',
    '#13C0FB',
    '#4198B5',
    '#588492',
    '#5E7F8A',
    '#647A81',
    '#6F6F6F',
  ];

  constructor(private http: HttpClient) {}

  getmapShapes(): Observable<any[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/mapShape')
      .pipe(map((response) => response));
  }

  getmapShape(id: number): Observable<any> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/mapShape/' + id)
      .pipe(map((response) => response));
  }

  savemapShape(mapShapeItem): Observable<any> {
    const mapShape = { ...mapShapeItem };
    delete mapShape.lastUpdated;
    delete mapShape.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    mapShape.companyId = companySelected ? companySelected.id : null;

    if (mapShape.id) {
      return this.http.put<any>(
        this.apiBaseUrl + 'api/private/v1/mapShape/' + mapShape.id,
        mapShape
      );
    } else {
      return this.http.post<any>(this.apiBaseUrl + 'api/private/v1/mapShape', mapShape);
    }
  }

  deletemapShape(mapShape: any): Observable<any> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/mapShape/' + mapShape.id).pipe(
      map(() => {
        return { id: mapShape.id };
      })
    );
  }

  getColorByProperty = (currentVal: any, type: string, propertiesDistinct: Array<any>): string => {
    ////  console.log('getColorByProperty');

    let result: string = null;
    // const currentVal = featureGeoJeson.getProperty(property);
    let specColor = null;
    if (type === 'string') {
      specColor = _.find(propertiesDistinct, (i) => {
        return i.equal === currentVal;
      });
    } else if (type === 'number') {
      specColor = _.find(propertiesDistinct, (i) => {
        return currentVal >= i.min && currentVal < i.max;
      });
    }
    if (specColor && specColor.error === false) {
      result = specColor.color;
    }
    return result;
  };

  generateDistinctMapByType = (
    values: Array<any>,
    type: string,
    reverseColors: boolean = false,
    gradient = 'greenRed'
  ): any => {
    const result = [];
    let isAllNumber = true;
    // Ipotesi  values string String
    const uniqueValues = Array.from(new Set(values));
    if (type === 'string') {
      _.each(uniqueValues, (val) => {
        if (!(typeof val === 'string')) {
          result.push({
            equal: val.toString(),
            color: this.getRandomColor(),
            error: false,
          });
        } else {
          result.push({
            equal: val,
            color: this.getRandomColor(),
            error: false,
          });
        }
      });
    } else if (type === 'number') {
      _.each(uniqueValues, (val) => {
        if (!_.isNumber(val)) {
          isAllNumber = false;
        }
      });
      if (isAllNumber) {
        // Ipotesi values number
        const min = _.min(values);
        const max = _.max(values);
        const delta = (max - min) / 10;

        let count = min;
        for (let a = 0; a < 10; a++) {
          let newMin = count + delta;

          // Se c'è un problema con gli arrotondamenti si forza l'ultimo valore al massimo presente
          if (a === 9 && newMin < max) {
            newMin = max;
          }
          result.push({
            min: count,
            max: newMin,
            color:
              gradient == 'greenRed'
                ? this.getColorByIndex(a, reverseColors)
                : this.getColorByParamGradient(a, reverseColors, gradient),
            error: false,
          });
          count = newMin;
        }
      }
    }
    return result;
  };

  getColorByParamGradient = (index, reverse = false, gradient) => {
    let colors = [];
    if (gradient == 'greenRed') {
      colors = this.greenRedGradientColor;
    } else if (gradient == 'blueRed') {
      colors = this.blueRedGradientColor;
    } else if (gradient == 'blueGrey') {
      colors = this.blueGreyGradientColor;
    } else {
      colors = this.greenRedGradientColor;
    }
    if (reverse) {
      colors.reverse();
    }
    return colors[index];
  };

  getColorByIndex = (index, reverse = false) => {
    const colors = [
      '#198012',
      '#31a012',
      '#59bc21',
      '#76c714',
      '#aeea1e',
      '#f6fe28',
      '#f7e324',
      '#d6861a',
      '#ef5921',
      '#de2f10',
    ];
    if (reverse) {
      colors.reverse();
    }
    return colors[index];
  };

  getRandomColor = (): string => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  generateColorConfiguration = (geoJson: any): any => {
    const result = {};
    const resultTMP = {};
    let havePoint = false;
    _.each(geoJson.features, (val: any) => {
      if (val.geometry.type === 'Point') {
        havePoint = true;
      }
      const keysTMP = _.keys(val.properties);
      _.each(keysTMP, (k) => {
        const listTMP: Array<any> = resultTMP[k];
        if (listTMP === undefined || listTMP === null) {
          resultTMP[k] = [];
        }
        resultTMP[k].push(val.properties[k]);
        result[k] = {};
      });
    });
    const resultTMPKeys = _.keys(resultTMP);
    _.each(resultTMPKeys, (val: any) => {
      if (resultTMP[val].length > 0) {
        const type = typeof resultTMP[val][0];
        if (type === 'string') {
          result[val]['discrete'] = this.generateDistinctMapByType(resultTMP[val], type);
        } else {
          if (!havePoint) {
            result[val]['discrete'] = this.generateDistinctMapByType(resultTMP[val], 'string');
          }
          result[val]['gradient'] = this.generateDistinctMapByType(resultTMP[val], 'number');
        }
      }
    });
    ////  console.log(result);
    return result;
  };

  sendPrescriptionMap(mapShapeIds): Observable<any> {
    const idsObj = {
      mapShapeIds: [mapShapeIds],
    };
    return this.http
      .post<any>(this.telemetryBaseUrl + 'api/private/v3/machine/sendPrescriptionMap', idsObj)
      .pipe(map((response) => response));
  }

  sendActivityPrescriptionMap(externalSource: string, fieldActivityId): Observable<any> {
    return this.http
      .get<any>(
        this.telemetryBaseUrl +
          'api/private/v3/machine/sendPrescriptionMap' +
          '?externalSource=' +
          externalSource +
          '&fieldActivityId=' +
          fieldActivityId
      )
      .pipe(map((response) => response));
  }

  /**
   * Sends task data to the specified provider.
   * @param provider The provider to send the task data to.
   * @param activityData The request object containing the task data.
   * @returns void.
   */
  sendTaskData(
    provider: SendTaskDataAvailableProviders,
    activityData: SendTaskDataRequest
  ): Observable<void> {
    return this.http
      .post<void>(`${this.telemetryMachineryBaseUrl}v1/taskdata/${provider}`, activityData)
      .pipe(map((response) => response));
  }
}
